import { REWARDS_REWARD_TYPES } from "@modules/nudges/types";
import { literal, nullable, number, object, string } from "superstruct";

export const RewardsFreeProductSchema = object({
    type: literal(REWARDS_REWARD_TYPES.freeProduct),
    discountValue: number(),
    productId: number(),
    productHandle: string(),
    productTitle: string(),
    productImage: nullable(string()),
});
